<template>
  <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="flat-secondary"
      class="btn-icon rounded-circle"
      v-b-tooltip.hover.html.v-secondary.top="tooltipConfig"
      @click="$emit('clicked')"
  >
    <feather-icon icon="InfoIcon" size="16" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'UserButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    tooltipConfig() {
      return {
        title: this.$t('RatingInformation'),
        customClass: 'tooltip-left-aligned'
      }
    }
  }
}
</script>

<style>
/* Nota: No usar 'scoped' para que los estilos del tooltip funcionen */
.tooltip-left-aligned .tooltip-inner {
  text-align: left !important;
  max-width: 300px;
}
</style>